import { forwardRef } from "react";

function Root(props, ref) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
  
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3324 29.5947H23.0546L24.5363 33.7886C24.5724 33.9119 24.6989 34 24.8254 33.9824H28.6021C28.7828 33.9824 28.837 33.8943 28.7828 33.7004L22.1872 15.5507C22.1691 15.4626 22.0968 15.4097 21.9523 15.4097H17.3263H17.2721C17.1817 15.4273 17.1095 15.5154 17.1275 15.6035C17.1275 15.9912 17.0914 16.3789 17.0191 16.7489C16.9679 16.8987 16.9258 17.0397 16.8863 17.1718C16.87 17.2262 16.8542 17.279 16.8384 17.3304L11.0198 33.6652C10.9656 33.8767 11.0198 33.9824 11.2186 33.9824H14.6158C14.7784 34 14.923 33.8943 14.9591 33.7357L16.3324 29.5947ZM21.9703 26.0176H17.3805C17.6516 25.2775 17.9226 24.4493 18.1756 23.5507C18.3546 23.0052 18.5267 22.4597 18.6961 21.9226C18.8003 21.5922 18.9036 21.2649 19.0068 20.9427C19.2598 20.185 19.4586 19.4273 19.6212 18.6696H19.6574C19.7279 18.9054 19.7984 19.1521 19.872 19.4097C19.9305 19.6143 19.9909 19.8257 20.0549 20.0441C20.1995 20.5551 20.3621 21.0661 20.5428 21.6123C20.6331 21.8855 20.719 22.1542 20.8048 22.4229C20.8906 22.6916 20.9765 22.9604 21.0668 23.2335C21.2295 23.7621 21.3921 24.2731 21.5547 24.7489C21.7174 25.2071 21.8619 25.6476 21.9703 26.0176Z"
        fill="#fff"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.1139 17.8062C31.5476 18.2115 32.1258 18.4405 32.7221 18.4229C33.3365 18.4581 33.9509 18.2291 34.3665 17.8062C34.8002 17.3656 35.017 16.7841 34.999 16.185C35.017 15.6035 34.8002 15.0396 34.4027 14.6167C34.0051 14.2115 33.463 14 32.7583 14C32.1619 14 31.5837 14.2115 31.15 14.6167C30.7163 15.022 30.4814 15.5859 30.4995 16.185C30.4814 16.7841 30.6983 17.3656 31.1139 17.8062ZM30.6983 20.1498V33.7181C30.6983 33.8943 30.7886 34 30.9693 34H34.5111C34.6737 34 34.746 33.9119 34.746 33.7181V20.1498C34.746 19.9912 34.6737 19.9031 34.5111 19.9031H30.9332C30.7705 19.9031 30.6983 19.9736 30.6983 20.1498Z"
        fill="#fff"
      />
    </svg>
  );
}
const Ai = forwardRef(Root);
export default Ai;
